import { Tenant } from '@/common/data/entities/Tenant'
import { UserEntity } from '@/common/data/entities/UserEntity'
import { authedRequest } from '@/common/services/api/requests'

const getDisplayName = async () => {
  let displayName = ''

  const response = await authedRequest('BaseBiz', '/TenantDetails', 'GET')
  const user = response.entity as UserEntity

  try {
    const userEmployee = await authedRequest('BaseBiz', '/Employee/List', 'POST', {
      fieldValues: { userAccountId: [user.id!] },
    })
    if (userEmployee.entity[0]) {
      const tenantResponse = await authedRequest('BaseBiz', '/GetTenant', 'GET')
      const tenant = tenantResponse.entity as Tenant

      displayName = userEmployee.entity[0].name + '@' + tenant.name
    } else {
      displayName = user.name
    }
  } catch (error) {
    console.error(error)
    displayName = user.name
  }

  return displayName
}

export default getDisplayName
